import type { ReactElement } from 'react'
import { useState } from 'react'

import { validator } from '@twistopayments/design-system/form'

import { TextField } from '../../molecules/text-field'

type Props = {
  label: ReactElement
  name: string
}

export const CardNumberField = ({ label, name }: Props) => {
  const [cardType, setCardType] = useState('unknown')

  const getCardProvider = (cardType: string) => {
    switch (cardType) {
      case 'visa':
        return 'visa'
      case 'mastercard':
        return 'mastercard'
      default:
        return 'other'
    }
  }

  return (
    <TextField
      cardProvider={getCardProvider(cardType)}
      inputProps={{
        autoComplete: 'off',
        autoFocus: true,
        formattedOptions: {
          creditCard: true,
          onCreditCardTypeChanged: (type) => setCardType(type),
        },
      }}
      label={label}
      name={name}
      rules={{
        required: validator.getValidationMessages().required,
        validate: validator.formValidators.isValidCardNumber,
      }}
      variant="card"
    />
  )
}
